import { TranscriptionCapability } from '@doxyme/extensions-bridge';
import { useCapability } from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

export type UseExtensionsTranscriptionReturnValue = {
  stop?: InstanceType<typeof TranscriptionCapability>['stop'];
};

export function useExtensionsTranscription(): UseExtensionsTranscriptionReturnValue {
  const transcription = useCapability<TranscriptionCapability>(
    bridge,
    TranscriptionCapability.id,
  );

  return {
    stop: transcription?.stop.bind(transcription),
  };
}
